<script setup lang="ts">
import DiveCenterWizard from '@/components/DiveCenterWizard.vue'

// Crear un dive center es solo del owner; el backend también lo valida.
definePage({ meta: { requiresAuth: true, ownerOnly: true } })
</script>

<template>
  <div
    class="mx-auto"
    style="max-width: 1100px;"
  >
    <DiveCenterWizard />
  </div>
</template>
